import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

export default function () {
	document.addEventListener('DOMContentLoaded', (event) => {
		const sliderElements = document.querySelectorAll<HTMLDivElement>(
			'[data-brands-slider-container]',
		)

		if (sliderElements.length > 0) {
			sliderElements.forEach((el) => {
				const sliderEl = el.querySelector<HTMLDivElement>('[data-brands-slider]')
				const controlsParent = el.querySelector<HTMLDivElement>('[data-brands-slider]')

				if (!sliderEl) return
				new Swiper(sliderEl, {
					spaceBetween: '24px',
					slidesPerView: 'auto',
					modules: [Navigation],
					speed: 500,
					navigation: {
						nextEl: '[data-swiper-button-next]',
						prevEl: '[data-swiper-button-prev]',
					}
				})
			})
		}
	})
}
